import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardActions, CardContent, CardHeader, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CouriersList from '@views/couriers/components/CouriersList';
import NewCourierForm from 'components/views/couriers/components/Form';
import CourierCard from '@views/couriers/components/CourierCard';
import AppFormProvider from '@shared/AppFormProvider';

import axios from 'utils/axios-rails';

const propTypes = {
  page: PropTypes.object,
  couriers: PropTypes.array.isRequired,
  pendingWork: PropTypes.object.isRequired,
  createCourierURL: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  canUpdate: PropTypes.bool,
}

const TeamShowAndEdit = (props) => {
  const [couriers, setCouriers] = useState(props.couriers);

  const [formState, setForm] = useState({
    active: false,
    action: "team"
  });
  const [selectedCourier, setSelectedCourier] = useState({});
  const [courierOrders, setCourierOrders] = useState([]);

  const submitForm = async (values, formikBag) => {
    const response = await axios.post(props.createCourierURL, {
      courier: {
        ...values
      }
    });
    let {data} = response;
    if(data.success){
      formikBag.setStatus({
        submitLoading: false,
        showToast: true,
        toastContent: I18n.t("messages.save_success")
      });
      setCouriers([
        ...couriers,
        data.record
      ]);
      setForm({
        active: false
      });
    }
    else{
      formikBag.setStatus({
        submitLoading: false,
        showToast: true,
        toastContent: I18n.t("messages.record_errors"),
      })
      formikBag.setErrors(data.errors);
    }
  }

  const selectCourier = async (courier) => {
    setCourierOrders([]);
    setSelectedCourier(courier);
    try {
      const response = await axios.get(`/teams/${props.team.id}/couriers/${courier.id}/get_orders`)
      setCourierOrders(response.data.orders);
    } catch (error) {
      alert("Ocurrio un error al traer la información de las ordenes para el mensajero.");
      console.log(error)
    }
  }

  return(
    <AppFormProvider
      pageProps={{
        ...props.page ,
        secondaryActions: !props.canUpdate ? [] : [
          {
            content: "Editar información",
            url: props.editURL,
            icon: <EditIcon />
          },
        ],
      }}
      defaultValues={{
        uid: "",
        phone: "",
        user_attributes: {}
      }}
      handleSubmit={ submitForm }
    >
    { ({
      handleChange, handleSubmit, values, errors, resetForm
    }) => {
      return(
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <div>
              <Card>
                <CardHeader
                  title={I18n.t("activerecord.models.courier.other")}
                  titleTypographyProps={{ variant: 'h6' }}
                />
                <CardContent>
                  <CouriersList
                    items={couriers}
                    pendingWork={props.pendingWork}
                    onClick={ (courier) => selectCourier(courier) }
                  />
                </CardContent>

                <CardActions sx={{ justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    disabled={formState.active}
                    onClick={() => { resetForm(); setForm({ ...formState, active: true, action: "courier" }) }}
                  >
                    { I18n.t("actions.create_x", { x: I18n.t("activerecord.models.courier.one") }) }
                  </Button>
                </CardActions>
              </Card>

              {/* Courier Form */}
              {formState.active &&
                <NewCourierForm
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  values={values}
                  errors={errors}
                  secondaryFooterActions={[
                    {
                      content: I18n.t("actions.cancel"),
                      onAction: () => { resetForm(); setForm({ active: false }) }
                    }
                  ]}
                />
              }
            </div>
          </Grid>

          {/* Right column to show selected courier info*/}
          <Grid item xs={12} md={4}>
            <CourierCard
              editURL={ selectedCourier.id && `/teams/${props.team.id}/couriers/${selectedCourier.id}/edit` }
              courier={selectedCourier}
              orders={ courierOrders }
            />
          </Grid>
        </Grid>
      )
    }}
  </AppFormProvider>
  );
}


TeamShowAndEdit.propTypes = propTypes;

export default TeamShowAndEdit;
